import Vue from "vue";
import analytics from "../services/analytics";

function initFilters(app:Vue.App) {
    const BBCodeArray = [
        "[BLOCKQUOTE]", "[/BLOCKQUOTE]", "[B]", "[/B]", "[I]", "[/I]", "[U]", "[/U]",
        "[TABLE]", "[/TABLE]", "[TR]", "[/TR]", "[TD]", "[/TD]", "[UL]", "[/UL]", "[LI]", "[/LI]", "[DEL]", "[/DEL]",
    ];

    app.config.globalProperties.$filters = {
        numberFilter(value, decimalPlaces): string {
            return Number(value).toFixed(decimalPlaces)
        },
        percentageFilter(value, digits = 2): string {
            if(value !== undefined){
                return `${value.toFixed(digits)}%`;
            }
            return '';
        },
        formatTrackingFilter(value: string): string {
            return analytics.formatTrackingLink(value);
        },
        currencyFilter(value: number, decimalPlaces: number = 2): string {
            return "$" + value.toFixed(decimalPlaces).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        currencyFormatFilter(value: number, max: number = 999999999): string {
            // If number is out of range, simply print dash (-)
            if (value < 1 || value > max) {
                return "-";
            }
    
            if (value < 999) {
                if (value.toString().endsWith("99")) {
                    value++;
                }
                return "$" + value.toFixed(0);
            }
            else if (value > 999999) {
                let roundedValue = value / 1000000;
                return "$" + roundedValue.toFixed(1).replace(".0", "") + "m";
            }
            else {
                let roundedValue = value / 1000;
                return "$" + roundedValue.toFixed(1).replace(".0", "") + "k";
            }
    
        },
        insurerTagFilter(insurers: string[]): string{
            if(!insurers){
                return "";
            }
            if (insurers.find(a => a.includes("FDIC")) || insurers.length == 0) {
                return "Member FDIC";
            } 
            if (insurers.find(a => a.includes("NCUA"))) {
                return "NCUA Insured";
            }
            return "";
        },
        insurerTagStringFilter(insurers: string): string{
            if(!insurers){
                return "";
            }
            if (insurers.indexOf("FDIC") >= 0) {
                return "Member FDIC";
            } 
            if (insurers.indexOf("NCUA") >= 0) {
                return "Insured by NCUA";
            }
            return "";
        },
        trimValueFilter(stringValue: string): string{
            return stringValue.trim();    
        },
        monthsFormatFilter(value: number, includeMonthsText: boolean = true): string {
            const calcMonths :string = Math.round(value/30.5).toString();
            return includeMonthsText ? calcMonths + "months" : calcMonths;
        },
        BBCodeToHtmlFilter(content: string): string {
            var compiledContent: string = content;
        
            BBCodeArray.forEach(x => {
                let regexStr = globalRegexString(x);
                compiledContent = compiledContent.replace(regexStr, x.toLowerCase().replace("[", "<").replace("]",">"));
            })
            
            let urlBBCodeList = compiledContent.match(/\[URL(.*?)\](.*?)\[\/(.*?)URL\]/g) || [];
            urlBBCodeList.forEach((urlBBCode) => {
                const isDASite :boolean = urlBBCode.toLowerCase().indexOf("http") == -1 || urlBBCode.toLowerCase().indexOf("//www.depositaccounts.com") > -1 || urlBBCode.toLowerCase().indexOf("//depositaccounts.com") > -1;
                const aTagBody = isDASite ? "<a href" : "<a rel='nofollow' target='_blank' class='external' href" 
                const urlHTMLCode = urlBBCode.replace("[URL", aTagBody).replace("[/URL]", "</a>").replace("]", ">");
                compiledContent = compiledContent.replace(urlBBCode, urlHTMLCode);
            }) 
            return compiledContent;
        }
    }
}
export default initFilters;

function globalRegexString(value: string): RegExp {
    var sanitizeVal = value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    return new RegExp(sanitizeVal, 'g');
}